// 只合并进行中的请求；结束后清理，后续刷新和失败重试仍会重新请求。
export const shareInFlight = <T>(
  load: () => Promise<T>,
  getKey: () => string,
): (() => Promise<T>) => {
  const pending = new Map<string, Promise<T>>();

  return () => {
    const key = getKey();
    const existing = pending.get(key);
    if (existing) return existing;

    const request = load().finally(() => {
      if (pending.get(key) === request) pending.delete(key);
    });
    pending.set(key, request);
    return request;
  };
};
